import request from "_private/utils/request";
const COMMON_MODULE_MONITOR_WEB = "/COMMON-MODULE-MONITOR-WEB";
const COMMON_MODULE_BASE_USER_WEB = "/COMMON-MODULE-BASE-USER-WEB";
const COMMON_MODULE_BASIC_ELEMENT_WEB = "/COMMON-MODULE-BASIC-ELEMENT-WEB";
const COMMON_MODULE_BASE_DRIVER_WEB = "/COMMON-MODULE-BASE-DRIVER-WEB";
const COMMON_MODULE_MEDIA_WEB = "/COMMON-MODULE-MEDIA-WEB";
const ACTIVE_SAFETY_WEB = "/BL-MODULE-ACTIVE-SAFETY-WEB";
const COMMON_MODULE_PERSONALIZE_WEB = "/COMMON-MODULE-PERSONALIZE-WEB";
const COMMON_MODULE_BASE_REPAY_WEB = "/COMMON-MODULE-BASE-REPAY-WEB";
const BL_MODULE_COLD_CHAIN_WEB = "/BL-MODULE-COLD-CHAIN-WEB";
const COMMON_MAP_API_WEB = "/E6-COMMON-MAP-API-WEB";
/***************** 公共接口 start ***************/
// 获取用户下拉树
const getUserTree = function() {
  return request({
    url: `${COMMON_MODULE_BASE_USER_WEB}/user/userTree`,
    method: "get"
  });
};

// 获取车辆下拉树
const getVehicleTree = function() {
  return request({
    url: `${COMMON_MODULE_MONITOR_WEB}/monitor/tree/getVehicleTree`,
    method: "get"
  });
};
// 获取车辆下拉列表
const getVehicleList = () => {
  return request({
    url: `${COMMON_MODULE_MONITOR_WEB}/monitor/tree/getVehicleList`,
    method: "get"
  });
};
// 获取司机下拉列表
const getDriverList = () => {
  return request({
    url: `${COMMON_MODULE_BASE_DRIVER_WEB}/driver/getDriverList`,
    method: "get"
  });
};
// 获取区域下拉列表
const getAreaList = () => {
  return request({
    url: `${COMMON_MODULE_BASIC_ELEMENT_WEB}/area/findAreaInfoListV2`,
    method: "get"
  });
};
/********************************视频回放*******************************/

// 切换视频倍速
const changeVideoSpeed = params => {
  return request({
    url: `${COMMON_MODULE_MEDIA_WEB}/replay/video/tabVideoSpeed`,
    method: "get",
    params
  });
};
// 根据经纬度获取地理位置
const fetchPositionByLonLat = params => {
  return request({
    url: `${COMMON_MAP_API_WEB}/place/geoInfo`,
    method: "get",
    params
  });
};
/**********************仓库实时视频********************* */
// 获取部门-仓库-摄像头树形结构选择
const getCameraTree = params => {
  return request({
    url: `/monitorCenter/storageVideo/getCameraTree`,
    method: "get",
    params
  });
};
// 获取摄像头的最新在线状态 "cameraIdList": [345,6545] //勾选的摄像头ID列表。没选时传[]
const getCameraLatestStatus = data => {
  return request({
    url: `/monitorCenter/storageVideo/getCameraLatestStatus`,
    method: "post",
    headers: { type: "json" },
    data
  });
};
//点击实时监控按钮-开始播放视频
const openRealTimeVideo = data => {
  return request({
    url: `/monitorCenter/storageVideo/openVideo`,
    method: "post",
    headers: { type: "json" },
    data
  });
};
// 获取每个摄像头的绑定监测点信息
const getPointMonit = data => {
  return request({
    url: `/monitorCenter/storageVideo/getPointMonit`,
    method: "post",
    data
  });
};
// 获取每个摄像头的绑定监测点信息
const closeRealTimeVideo = data => {
  return request({
    url: `/monitorCenter/storageVideo/closeVideo`,
    method: "post",
    headers: { type: "json" },
    data
  });
};
/**********************仓库回放视频********************* */
// 根据选择的监测点ID获取其绑定的摄像头列表
const getCameraListByPointId = params => {
  return request({
    url: `/monitorCenter/storageVideo/getCameraListByPointId`,
    method: "post",
    params
  });
};
// 根据监测点id+时间段，查询各类报警时段列表
const getPointAlarmPeriodList = data => {
  return request({
    url: `${BL_MODULE_COLD_CHAIN_WEB}/cold/storageReplayVideo/getPointAlarmPeriodList`,
    method: "post",
    data
  });
};
// 摄像头开始回放视频（支持批量）
const replayVideo = data => {
  return request({
    url: `/monitorCenter/storageVideo/replayVideo`,
    method: "post",
    headers: { type: "json" },
    data
  });
};
// 查询监测点树
const getStorageLocationPointTree = params => {
  return request({
    url: `${BL_MODULE_COLD_CHAIN_WEB}/cold/storageAlarm/getStorageLocationPointTree`,
    method: "get",
    params
  });
};
// 查询温湿度曲线
const queryStorageHumitureDetails = data => {
  return request({
    url: `${BL_MODULE_COLD_CHAIN_WEB}/storage/queryStorageHumitureDetails`,
    method: "post",
    data
  });
};
// 停止回放视频（批量）
const stopReplayVideo = data => {
  return request({
    url: `/monitorCenter/storageVideo/stopReplayVideo`,
    method: "post",
    headers: { type: "json" },
    data
  });
};
export default {
  getUserTree,
  getVehicleTree,
  getVehicleList,
  getDriverList,
  getAreaList,
  fetchPositionByLonLat,
  changeVideoSpeed,
  getCameraTree,
  getCameraLatestStatus,
  openRealTimeVideo,
  getPointMonit,
  closeRealTimeVideo,
  getCameraListByPointId,
  getPointAlarmPeriodList,
  replayVideo,
  getStorageLocationPointTree,
  queryStorageHumitureDetails,
  stopReplayVideo
};
